import CloseIcon from '@mui/icons-material/Close';
import { Box, IconButton, Tooltip, Typography } from "@mui/material";
import { useTheme } from '@mui/material/styles';
// key, anchor, open, setIsOpen are required
export default function OverlayTitle(props) {
    const { sx = {},noBackground=false,lengthOfInsights=0 } = props;
    const theme = useTheme();
    return (
        <Box
            sx={{
                display: "flex",
                alignItems: "center",
                width: "100%",
                borderTopLeftRadius: "4px",
                borderTopRightRadius: "4px",
                backgroundColor: noBackground ? "" : theme?.custom?.mainBackgroundColor,
                padding: "6px 10px 6px 16px",
                ...sx,
            }}
        >
            <Typography
                className="OverlayTitleText"
                sx={{ lineHeight: "30px", flexGrow: "1",fontWeight: 700}}
            >
                {props.title} {lengthOfInsights>0 && `(${lengthOfInsights})`}
            </Typography>
            {!!props.onClose && (
                <Tooltip title="Close">
                    <IconButton>
                        <CloseIcon
                            sx={{
                                justifySelf: "end",
                                "&:hover": {
                                    opacity: 0.9,
                                    cursor: "pointer",
                                    color: theme?.custom?.mainButtonHighlight,
                                },
                            }}
                            onClick={() => {
                                props.onClose();
                            }}
                        />
                    </IconButton>
                </Tooltip>
            )}
        </Box>
    );
}
